import { render } from "./ColorPicker.vue?vue&type=template&id=bf33e752&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"

import "./ColorPicker.vue?vue&type=style&index=0&id=bf33e752&scoped=true&lang=css"
import "./ColorPicker.vue?vue&type=style&index=1&id=bf33e752&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf33e752"]])

export default __exports__